module.exports = __webpack_public_path__ + "static/media/doulanshan_plant.33218abb.webp";